import React from 'react'
import styled from 'styled-components'
import iconCloseXDark900 from '~/assets/icons-light-theme/icon-close-x-dark900.svg'
import iconCallRingBlue from '~/assets/icons/icon-call-ring-blue.png'
import Linkify from '~/components/Linkify'
import { dimensions, light, spacing } from '~/constants/theme'

import { FontStyle, Text } from './core'
import { ImageIcon } from './ImageIcon'

const RootWrapper = styled.div`
  width: 100%;
  padding: ${spacing.spacingXXL};
  box-sizing: border-box;
`

const StatusInfoWrapper = styled.div`
  width: 100%;
  border-radius: ${dimensions.borderRadiusSM};
  overflow: hidden;
  background-color: ${light.gray100};
`

const StatusHeaderWrapper = styled.div<{ error: boolean }>`
  width: 100%;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid ${light.gray400};
  background-color: ${(props) =>
    props.error ? `${light.redFocus}` : `${light.greenAlert}`};
`

const StatusHeaderContent = styled.div`
  width: calc(100% - 30px);
  height: 100%;
  display: flex;
  align-items: center;
`

const StatusImageWrapper = styled.div`
  width: 35px;
  height: 35px;
  padding: ${spacing.spacingMD};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
`

const StatusInfoContent = styled.div`
  width: 100%;
  padding: ${spacing.spacingLG};
  display: flex;
  align-items: center;
  box-sizing: border-box;
`

interface StatusToastProps {
  title: string
  icon?: string
  message: string
  error: boolean
  onClose: () => void
}
const StatusToast = ({
  title,
  icon = iconCallRingBlue,
  message,
  error,
  onClose,
}: StatusToastProps) => {
  return (
    <RootWrapper>
      <StatusInfoWrapper>
        <StatusHeaderWrapper error={error}>
          <StatusHeaderContent>
            <StatusImageWrapper>
              <ImageIcon width={17} height={17} url={icon} />
            </StatusImageWrapper>
            <Text
              fontStyle={FontStyle.bSmall}
              text={title}
              color={light.dark900}
            />
          </StatusHeaderContent>
          <ImageIcon
            width="12"
            height="12"
            marginRight="12"
            cursor
            icon={iconCloseXDark900}
            onClick={onClose}
          />
        </StatusHeaderWrapper>
        <StatusInfoContent>
          <Linkify>
            <Text
              fontStyle={FontStyle.Small}
              color={error ? light.dark700 : light.dark900}
            >
              {message}
            </Text>
          </Linkify>
        </StatusInfoContent>
      </StatusInfoWrapper>
    </RootWrapper>
  )
}

export default StatusToast
